import _toConsumableArray from "@babel/runtime-corejs3/helpers/esm/toConsumableArray";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import capitalize from "lodash/capitalize";
import numberConverter from "number-to-words";
import getDatePartValue from "./getDatePartValue.js";

// This takes a date and converts it into words using a template string
// e.g.: dateTimeToWords(date, '%M %DOW, %y at %HW%MW %b') => "February Twelfth, 2022 at Twelve-Fifteen AM"

// Here's the key:
// weekday: %E => Monday
// month: %M => January
// day: %d => 25
// dayOrdinalWords: %dow => twenty-fifth
// dayOrdinalWordsTitle: %DOW => Twenty-Fifth
// year: %y => 2020
// yearWords: %yw => two thousand twenty-two
// yearWordsTitle: %YW => Two Thousand Twenty-Two
// hour: %h => 11
// hourWords: %hw => eleven
// hourWordsTitle: %HW => Eleven
// minute: %m => 59
// minuteWords: %mw => fifty-nine
// minuteWordsTitle: %MW => -Fifty-Nine
// dayPeriod: %b => PM
// dayPeriodWords: %bw => In The Evening

function getDateParts(date) {
  var formatter = new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZone: 'UTC'
  });
  return formatter.formatToParts(date);
}
var toWords = function toWords(input) {
  return numberConverter.toWords(input);
};
var toWordsOrdinal = function toWordsOrdinal(input) {
  return numberConverter.toWordsOrdinal(input);
};
var toWordsStripCommas = function toWordsStripCommas(input) {
  return toWords(input).replace(/,/g, '');
};
var titleCase = function titleCase(input) {
  var _context;
  return _mapInstanceProperty(_context = input.split(/([\s-]+)/g)).call(_context, capitalize).join('');
};
var wordsIfNotZero = function wordsIfNotZero(input) {
  return input === '00' ? '' : toWords(input);
};
var dashWordsIfExists = function dashWordsIfExists(input) {
  return input.length === 0 ? '' : "-".concat(titleCase(input));
};
function addCustomDateParts(dateParts) {
  var parts = _toConsumableArray(dateParts);
  var additions = [{
    sourceKey: 'year',
    key: 'yearWords',
    transform: toWordsStripCommas
  }, {
    sourceKey: 'yearWords',
    key: 'yearWordsTitle',
    transform: titleCase
  }, {
    sourceKey: 'day',
    key: 'dayOrdinalWords',
    transform: toWordsOrdinal
  }, {
    sourceKey: 'dayOrdinalWords',
    key: 'dayOrdinalWordsTitle',
    transform: titleCase
  }, {
    sourceKey: 'hour',
    key: 'hourWords',
    transform: toWords
  }, {
    sourceKey: 'hourWords',
    key: 'hourWordsTitle',
    transform: titleCase
  }, {
    sourceKey: 'minute',
    key: 'minuteWords',
    transform: wordsIfNotZero
  }, {
    sourceKey: 'minuteWords',
    key: 'minuteWordsTitle',
    transform: dashWordsIfExists
  }, {
    sourceKey: 'dayPeriod',
    key: 'dayPeriodWords',
    transform: function transform(input) {
      return input === 'AM' ? 'In The Morning' : 'In The Evening';
    }
  }];

  // https://contest-server.cs.uchicago.edu/ref/JavaScript/developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts.html
  // also check lowercase to account for the possible above bug
  _forEachInstanceProperty(additions).call(additions, function (_ref) {
    var sourceKey = _ref.sourceKey,
      key = _ref.key,
      transform = _ref.transform;
    var part = _findInstanceProperty(parts).call(parts, function (p) {
      return p.type === sourceKey || p.type === sourceKey.toLowerCase();
    });
    if (part) {
      parts.push({
        type: key,
        value: transform(part.value)
      });
    }
  });
  return parts;
}
var templateReplacements = [{
  key: 'weekday',
  regex: /%E/g
}, {
  key: 'dayOrdinalWords',
  regex: /%dow/g
}, {
  key: 'dayOrdinalWordsTitle',
  regex: /%DOW/g
}, {
  key: 'day',
  regex: /%d/g
}, {
  key: 'yearWords',
  regex: /%yw/g
}, {
  key: 'yearWordsTitle',
  regex: /%YW/g
}, {
  key: 'year',
  regex: /%y/g
}, {
  key: 'hourWords',
  regex: /%hw/g
}, {
  key: 'hourWordsTitle',
  regex: /%HW/g
}, {
  key: 'hour',
  regex: /%h/g
}, {
  key: 'minuteWords',
  regex: /%mw/g
}, {
  key: 'minuteWordsTitle',
  regex: /%MW/g
}, {
  key: 'minute',
  regex: /%m/g
}, {
  key: 'month',
  regex: /%M/g
}, {
  key: 'dayPeriodWords',
  regex: /%bw/g
}, {
  key: 'dayPeriod',
  regex: /%b/g
}];
export default function dateTimeToWords(date, template) {
  var dateParts = getDateParts(date);
  var customDateParts = addCustomDateParts(dateParts);
  var formattedDate = template;
  _forEachInstanceProperty(templateReplacements).call(templateReplacements, function (_ref2) {
    var key = _ref2.key,
      regex = _ref2.regex;
    formattedDate = formattedDate.replace(regex, getDatePartValue(customDateParts, key));
  });
  return formattedDate;
}